import axios from "axios";
const state = {
    serviceLines: [],
    allServiceLines: [],
    exportServiceLines: [],
    isDeleted:false
};

const getters = {
    ServiceLines: (state) => state.serviceLines,
    AllServiceLines: (state) => state.allServiceLines,
    ExportServiceLines: (state) => state.exportServiceLines,
    IsDeleted: (state) => state.isDeleted
};

const actions = {
    async GetCalendarServiceLines({ commit },calendarRequest) {
        await axios.get(`${process.env.VUE_APP_APIURL}servicelines/calendar/${calendarRequest.month}/${calendarRequest.year}/${calendarRequest.lang}`)
          .then((response) => {
              commit("setAllServiceLines", response.data);
          })
          .catch((error) => {
              console.log(error)
          });
    }, 

    async GetListServiceLinesAdmin({ commit }, serviceLinesRequest) {
        //search=titre&lang=en&page=0
        let request="";
        if(serviceLinesRequest.search!='' && serviceLinesRequest.search!=null && serviceLinesRequest.search!=undefined){
            request+=`search=${serviceLinesRequest.search}&`;
        }
        request+=`lang=${serviceLinesRequest.lang}&page=${serviceLinesRequest.page}`;
        if(serviceLinesRequest.sort!=undefined){
            request+=`&sort=${serviceLinesRequest.sort}&direction=${serviceLinesRequest.direction}`;
        }
        else{
            request+=`&sort=sli_startat&direction=DESC`;
        }
        console.log(`${process.env.VUE_APP_APIURL}servicelines?${request}`);
        await axios.get(`${process.env.VUE_APP_APIURL}servicelines?${request}`)
          .then((response) => {
              commit("setAllServiceLines", response.data);
          })
          .catch((error) => {
              console.log(error)
          });
    },  
    async ExportServiceLinesAdmin({ commit }, serviceLinesRequest) {
        //search=titre&lang=en&page=0
        let request="";
        if(serviceLinesRequest.lang!=undefined) request+=`lang=${serviceLinesRequest.lang}`;
        if(serviceLinesRequest.sort!=undefined){
            request+=`&sort=${serviceLinesRequest.sort}&direction=${serviceLinesRequest.direction}`;
        }
        else{
            request+=`&sort=sli_startat&direction=DESC`;
        }
        console.log(`${process.env.VUE_APP_APIURL}servicelines?${request}`);
        await axios.get(`${process.env.VUE_APP_APIURL}servicelines?${request}`)
          .then((response) => {
              commit("setExportServiceLines", response.data);
          })
          .catch((error) => {
              console.log(error)
          });
    },     
    async GetListServiceLines({ commit }, serviceLinesRequest) {
        //search=titre&lang=en&page=0
        let request="";
        if(serviceLinesRequest.search!='' && serviceLinesRequest.search!=null && serviceLinesRequest.search!=undefined){
            request+=`search=${serviceLinesRequest.search}&`;
        }

        //year and filter
        if (!serviceLinesRequest.filter) {
            //PR-2023
            
        } else if(serviceLinesRequest.filter=='year'){
            request+=`filter=year&year=${serviceLinesRequest.year}&`;
        } else {
            request+=`filter=${serviceLinesRequest.filter}&`;
        }

        //type
        if(serviceLinesRequest.type > 0)
            request += `type=${serviceLinesRequest.type}&`;
        
        if(serviceLinesRequest.all)
            request += `all&`;

        request+=`lang=${serviceLinesRequest.lang}&sort=sli_startat&direction=DESC`;
        await axios.get(`${process.env.VUE_APP_APIURL}servicelines?${request}`)
          .then((response) => {
              commit("setAllServiceLines", response.data);
          })
          .catch((error) => {
              console.log(error)
          });
    }, 

    async CreateServiceLine({ commit }, payload) {
        // Backward compatible: payload can be the body (FormData) or an object { body, config }
        const body = payload && payload.body ? payload.body : payload;
        const config = payload && payload.config ? payload.config : undefined;
        return await axios.post(`${process.env.VUE_APP_APIURL}servicelines`, body, config)
          .then(response => {
            return response.data;
          })
          .catch((error) => {
            // Propager l'erreur au composant
            return Promise.reject(error);
          });
    },  

    async UpdateServiceLine({ commit }, { id, formData, config }) {
        return await axios.post(`${process.env.VUE_APP_APIURL}servicelines/${id}`, formData, config)
          .then(response => {
            return response.data;
          })
          .catch((error) => {
            // Propager l'erreur au composant
            return Promise.reject(error);
          });
    },     

    GetServiceLine({ commit }, id) {
      return axios.get(`${process.env.VUE_APP_APIURL}servicelines/${id}`)
        .then(response => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
    }, 

    // async UpdateOrder({ commit }, body) {
    //   await axios.put(`${process.env.VUE_APP_APIURL}servicelines/reorder`, body)
    //     .then((response) => {
    //         commit("setAllServiceLines", response.data);
    //     })
    //     .catch((error) => {
    //         console.log(error)
    //     });
    // },

    async DeleteServiceLine({ commit, rootState }, id) {
        console.log('rootState', rootState.servicelineModule.allServiceLines)
        rootState.servicelineModule.isDeleted=false;
        await axios.post(`${process.env.VUE_APP_APIURL}servicelines/delete/${id}`)
          .then(res => {
            rootState.servicelineModule.isDeleted=true;
              /*if(res.data.success){
                let servicelines = rootState.servicelineModule.allServiceLines.list;
                var flist = servicelines.filter(function(list_item) {
                    return list_item.sli_id != id;
                });          
                //commit("setAllServiceLines", flist);
                state.allServiceLines.list = flist;
                if(state.allServiceLines.totalItems>0){
                    state.allServiceLines.totalItems =state.allServiceLines.totalItems-1;
                }
              }*/
          })
          .catch((error) => {
              console.log(error)
          });
    },

    async DownloadFile({ commit, rootState }, { type, filename }) {
        try {
            const url = `${process.env.VUE_APP_APIURL}servicelines/download-file/${type}/${filename}`;
            const response = await axios({
                method: 'GET',
                url: url,
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            console.error('Une erreur est survenue lors du téléchargement du fichier :', error);
            throw error;
        }
    }    
}

const mutations = {
    setServiceLines(state, serviceLines) {
        state.serviceLines = serviceLines;
    },
    setAllServiceLines(state, serviceLines) {
        state.allServiceLines = serviceLines;
    },
    setExportServiceLines(state, serviceLines) {
        state.exportServiceLines = serviceLines;
    }    
};

export default {
    state,
    getters,
    actions,
    mutations,
};